import { isRejectedWithValue, type Middleware } from '@reduxjs/toolkit';
import { isUserLoggedIn } from 'utils/auth';
import { emitApiEvent } from 'utils/apiEvents';

// These calls have their own, more specific messages (wrong password, rate limit on login, ...).
const OWN_MESSAGE_ENDPOINTS = ['login', 'register', 'requestResetPassword', 'resetPassword', 'confirmEmail'];

/** Turns failed API calls into UI events: expired session (401 with a token), 429 and no connection. */
export const apiEventsMiddleware: Middleware = () => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const endpoint: string = (action).meta?.arg?.endpointName ?? '';
    const status = (action.payload)?.status;

    if (!OWN_MESSAGE_ENDPOINTS.includes(endpoint)) {
      if (status === 401 && isUserLoggedIn()) {
        emitApiEvent('sessionExpired');
      } else if (status === 429) {
        emitApiEvent('tooManyRequests');
      } else if (status === 'FETCH_ERROR' || (typeof navigator !== 'undefined' && !navigator.onLine)) {
        emitApiEvent('offline');
      }
    }
  }

  return next(action);
};
